

export default {
  title: "Lucas Builds", 
  intro: "",
  about: {
    bio: "",
    email: "ldrummond.contact@gmail.com",
    phone: "510.717.0590", 
    resume: {
      src: "", 
    },
    social: [
      {
        title: "LinkedIn",
        link: "",
        icon: "", 
      },
      {
        title: "Behance",
        link: "",
        icon: "", 
      },
    ],
  },
}